import { OutlineEffect } from 'three/examples/jsm/effects/OutlineEffect.js';
import * as THREE from 'three';

class EffectHelper {
    initializeOutlineRenderer(hotspotScene, camera, renderer) {
        var effect = new OutlineEffect(renderer, {});
        let objectsInScene = [];

        for (let i = 0; i < hotspotScene.children.length; i++) {
            for (let j = 0; j < hotspotScene.children[i].children.length; j++) {
                if (hotspotScene.children[i].children[j].type === "Mesh") {
                    objectsInScene.push(hotspotScene.children[i].children[j]);
                }
            }
        }

        function edgeDistances(item) {
            const geometry = item.geometry;
            const vertices = geometry.attributes.position.array;
        
            let minDistance = Infinity;
            let maxDistance = -Infinity;
        
            for (let i = 0; i < vertices.length; i += 3) {
                const vertex = new THREE.Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);
                vertex.applyMatrix4(item.matrixWorld);
        
                const distance = camera.position.distanceTo(vertex);
                minDistance = Math.min(minDistance, distance);
                maxDistance = Math.max(maxDistance, distance);
            }
        
            return { closest: minDistance, furthest: maxDistance };
        }

        function sortObjects() {
            let renderOrder = 2;
    
            let sortedObjects = objectsInScene.sort((a, b) => {
                let distanceA = edgeDistances(a);
                let distanceB = edgeDistances(b);

                let avgA = (distanceA.closest + distanceA.furthest) / 2;
                let avgB = (distanceB.closest + distanceB.furthest) / 2;
                return avgA - avgB;
                
            });

            sortedObjects.forEach((item) => {
                item.renderOrder = renderOrder++;

                if(!item.name.toLowerCase().includes("stroke") && item.name.includes('_') && item.renderOrder < 10) {                    
                    item.onBeforeRender = (renderer) => {
                    const gl = renderer.getContext();
                    gl.enable(gl.STENCIL_TEST);
                    gl.stencilMask(0xff);
                    gl.stencilFunc(gl.NOTEQUAL, 1, 0xff);
                    gl.stencilOp(gl.KEEP, gl.KEEP, gl.REPLACE);
                  };
            
                  item.onAfterRender = (renderer) => {
                      const gl = renderer.getContext();
                      gl.enable(gl.STENCIL_TEST);
                      gl.stencilMask(0xff);
                      gl.stencilFunc(gl.NOTEQUAL, 1, 0xff);
                      gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
                  };
                } else {
                    item.onAfterRender = (renderer) => {
                        const gl = renderer.getContext();
                        gl.stencilMask(0xff);
                        gl.stencilFunc(gl.ALWAYS, 1, 0xff);
                        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
                        gl.disable(gl.STENCIL_TEST);
                    };
                }
                
            });

                    
        }

        function render() {
            sortObjects();
            effect.render(hotspotScene, camera);
        }

        return render;
    }
}

export default new EffectHelper();
